// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XACb","delete":"styles_delete__eOvAB","update":"styles_update__2IaS7","add":"styles_add__2GhnI"};